'use strict';

if (!window.Promise) {
  require('es6-promise').polyfill();
}

import axios from 'axios';

function validate() {
  const apiPrefix = !window.COOKIE_NOTIFICATION_LOCALHOST ?
    'https://www.wix.com/_api/marketing-cookie-notification' :
    '/api';

  return axios.get(`${apiPrefix}/allowed`, {withCredentials: true, headers: {'Content-Type': 'application/json'}});
}

export {validate};



// WEBPACK FOOTER //
// ./modules/geoValidator.js